// extracted by mini-css-extract-plugin
export var cta = "cta-module--cta--70deb";